import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { IProduct, IVariant } from 'src/app/features/produits/models/products.models';
import { IGeneralRules, SaveCustomData } from '../../models/catalogs.models';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AppState } from 'src/app/core/app.state';
import { Store } from '@ngrx/store';
import { ofType } from '@ngrx/effects';
import { MatDialog } from '@angular/material/dialog';
import { CustomeOverrideComponent } from '../custome-override/custome-override.component';
import { environment } from 'src/environments/environment';

import { customValidator, numericOnlyValidator } from 'src/app/shared/validators/fields-validators';
import { TranslateService } from '@ngx-translate/core';
import { selectCanDo } from 'src/app/core/store/permissions/permissions.selectors';
import { Subscription } from 'rxjs';
import { HasPermissionContext } from 'src/app/shared/has-permission.directive';
@Component({
  selector: 'app-custom-catalog-products',
  templateUrl: './custom-catalog-products.component.html',
  styleUrls: ['./custom-catalog-products.component.scss']
})
export class CustomCatalogProductsComponent implements OnInit, OnDestroy {
  form!: FormGroup;
  productsForm!: FormGroup;
  @Output() saveCustomProducts = new EventEmitter<SaveCustomData>();
  @Output() saveGeneraleRule = new EventEmitter<IGeneralRules>();
  @Output() cancelCustom = new EventEmitter<string>();
  @Input() selectedProducts0: IProduct[] = [];
  @Input() submitType: string = '';
  @Input() edit: boolean = false;
  selectedProducts: IProduct[] = [];
  @Input() generalRules0!: IGeneralRules;
  generalRules!: IGeneralRules;
  expandedIndex: number = -1;
  baseUrl = environment.BASE_URL_API;
  invalidProductIds!: number[];
  canSubmit = false;
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    public dialog: MatDialog,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.selectedProducts = [...this.selectedProducts0];
    this.generalRules = this.generalRules0;
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      return {
        ...product,
        discount: product.discount ? product.discount : this.generalRules.general_discount ?? 0,
        final_price: product.final_price ? product.final_price : this.getFinalPrice(product),
        increment: product.increment ? product.increment : this.generalRules.increment,
        min_qte: product.min_qte ? product.min_qte : this.generalRules.min_qte,
        max_qte: product.max_qte ? product.max_qte : this.generalRules.max_qte,
        can_be_sold_out_of_stock: product.can_be_sold_out_of_stock ?? this.generalRules.can_be_sold_out_of_stock,
        variants: (product.variants && product.variants.length > 0 ) ? product.variants.map((variant: IVariant) => {
          return {
            ...variant,
            discount: variant.discount ? variant.discount : this.generalRules.general_discount ?? 0,
            final_price: variant.final_price ? variant.final_price : this.getFinalPrice(variant),
            increment: variant.increment ? variant.increment : this.generalRules.increment,
            min_qte: variant.min_qte ? variant.min_qte : this.generalRules.min_qte,
            max_qte: variant.max_qte ? variant.max_qte : this.generalRules.max_qte,
            can_be_sold_out_of_stock: variant.can_be_sold_out_of_stock ?? this.generalRules.can_be_sold_out_of_stock,
          }
        }) : []
      }
    })

    this.initializeForm();
    this.productsForm = this.fb.group({
    });
    this.selectedProducts.forEach((product: IProduct, index) => {
      if(product.variants?.length === 0) {
        this.productsForm.addControl(`final_price_${product.id}`, new FormControl(product.final_price ?? '', [Validators.required]));
      }

      product.variants!.forEach((variant: IVariant) => {
        this.productsForm.addControl(`variant_${variant.id}_final_price`, new FormControl(variant.final_price ?? '', [Validators.required]));
      })
    });

    const action = this.submitType === 'stepper' ? 'create' : 'edit';
    const sub = this.store.select(selectCanDo('catalog', action)).subscribe((canSubmit) => {
      this.canSubmit = canSubmit;
      if (canSubmit) {
        this.form.enable({ emitEvent: false });
        this.productsForm.enable({ emitEvent: false });
      } else {
        this.form.disable({ emitEvent: false });
        this.productsForm.disable({ emitEvent: false });
      }
    });
    this.subscriptions.push(sub);
  }

  toggleVariants(id: number) {
    this.expandedIndex = this.expandedIndex === id ? -1 : id;
    if(this.invalidProductIds && this.invalidProductIds.includes(id)) {
      this.invalidProductIds = this.invalidProductIds.filter((invalidId) => invalidId != id);
    }
  }

  private initializeForm(): void {
    this.form = this.fb.group({
      general_discount: new FormControl(this.generalRules?.general_discount ?? '', [Validators.required]),
      increment: new FormControl(this.generalRules?.increment ?? 1, []),
      max_qte: new FormControl(this.generalRules?.max_qte ?? null),
      min_qte: new FormControl(this.generalRules?.min_qte ?? 1, []),
      can_be_sold_out_of_stock: new FormControl(this.generalRules?.can_be_sold_out_of_stock ?? false, [Validators.required]),
      show_stock: new FormControl(this.generalRules?.show_stock ?? true, [Validators.required]),
    }, { validators: customValidator(this.translateService) });

    this.form.get('show_stock')?.valueChanges.subscribe((value: boolean) => {
      if (value === false) this.form.get('can_be_sold_out_of_stock')?.setValue(true);
    })

    this.form.get('can_be_sold_out_of_stock')?.valueChanges.subscribe((value: boolean) => {
      if (value === false) this.form.get('show_stock')?.setValue(true);
    })
  }

  onDiscountChange(event: any, product: IProduct) {
    if (!this.canSubmit) return;
    let discount = event.target.value
    if (discount.endsWith(',') || discount.endsWith('.')) return;
    const [_, dec] = discount.split(/[,.]/)
    if (dec && dec.length > 2) {
      discount = Number((+discount).toFixed(2))
      event.target.value = discount
    }
    discount = Number(discount)
    if (discount < 0 || discount > 100) {
      discount = Math.min(Math.max(discount, 0), 100);
      event.target.value = discount
    }

    product.discount = discount;

    const newFinalPrice = this.getFinalPrice(product);
    product.final_price = newFinalPrice;

    if(newFinalPrice) {
      const controlName = 'final_price_' + product.id;
      const control = this.productsForm.get(controlName);
      if (control) {
        control.setValue(newFinalPrice, { emitEvent: false });
      }
    }

    if(product.variants && product.variants.length > 0 ){
      product.variants = product.variants?.map(variant => {
        // Recalculate the final price
        variant.discount = discount;
        const finalPrice = this.getFinalPrice(variant);
        if(finalPrice) {
          const controlName = 'variant_' + variant.id + '_final_price';

          const control = this.productsForm.get(controlName);
          if (control) {
            control.setValue(finalPrice, { emitEvent: false });
          }
        }

        return {
          ...variant,
          discount: discount,
          final_price: finalPrice
        }
      })
    }
  }

  onDiscounVariantChange(event: any, index: number, currentVariant: IVariant) {
    if (!this.canSubmit) return;
    let discount = event.target.value
    if (discount.endsWith(',') || discount.endsWith('.')) return;
    const [_, dec] = discount.split(/[,.]/)
    if (dec && dec.length > 2) {
      discount = Number((+discount).toFixed(2))
      event.target.value = discount
    }
    discount = Number(discount)
    if (discount < 0 || discount > 100) {
      discount = Math.min(Math.max(discount, 0), 100);
      event.target.value = discount
    }

    currentVariant.discount = discount;

    const newFinalPrice = this.getFinalPrice(currentVariant);
    currentVariant.final_price = newFinalPrice;

    if(newFinalPrice) {
      const controlName = 'final_price_' + currentVariant.id;
      const control = this.productsForm.get(controlName);
      control?.setValue(newFinalPrice, { emitEvent: false });
    }
  }

  getFinalPrice(product: IProduct | IVariant): number | null {
    const discount = product.discount ?? this.generalRules.general_discount ?? 0;
    return product.sales_price
    ? (+(product.sales_price * (1 - (discount / 100))).toFixed(2)) : null;
  }

  onFinalPriceChange(event: any, index: number, product: IProduct) {
    if (!this.canSubmit) return;
    let finalPrice = event.target.value, key = event.data;
    if ([',', '.'].includes(key)) {
      return;
    }
    const [_, dec] = finalPrice.split(/[,.]/)
    if (dec && dec.length > 2) {
      finalPrice = Number((+finalPrice).toFixed(2))
      event.target.value = finalPrice
    }
    finalPrice = Number(finalPrice);
    const priceUnit = product.sales_price ? Number(product.sales_price) : null;
    const targetedProduct = this.selectedProducts[index];

    if (finalPrice <= 0) {
      event.target.value = 0;
      product.final_price = 0;
      product.discount = 100;
      return;
    }
    if (priceUnit !== null && finalPrice > priceUnit) {
      event.target.value = priceUnit;
      product.final_price = priceUnit;
      product.discount = 0;
      return;
    }

    targetedProduct.final_price = finalPrice;
    targetedProduct.discount = targetedProduct.sales_price ? Number(100 - (finalPrice * 100 / targetedProduct.sales_price)) : 0;
  }

  onFinalPriceVariantChange(event: any, index: number, currentVariant: IVariant) {
    if (!this.canSubmit) return;
    let finalPrice = event.target.value, key = event.data;
    if ([',', '.'].includes(key)) {
      return;
    }
    const [_, dec] = finalPrice.split(/[,.]/)
    if (dec && dec.length > 2) {
      finalPrice = Number((+finalPrice).toFixed(2))
      event.target.value = finalPrice
    }
    finalPrice = Number(finalPrice);
    const priceUnit = Number(currentVariant.sales_price);

    if (finalPrice <= 0) {
      event.target.value = 0;
      currentVariant.final_price = 0;
      currentVariant.discount = 100;
      return;
    }
    if (finalPrice > priceUnit) {
      event.target.value = priceUnit;
      currentVariant.final_price = priceUnit;
      currentVariant.discount = 0;
      return;
    }

    currentVariant.final_price = finalPrice;

    currentVariant.discount = currentVariant.sales_price ? Number(100 - (finalPrice * 100 / currentVariant.sales_price)) : 0;
  }

  onGeneralDiscountChange(event: any){
    if (!this.canSubmit) return;
    const input = event.target, key = event.data;
    if ([',', '.'].includes(key)) {
      return;
    }
    const value = input.value < 0 ? 0 : input.value > 100 ? 100 : +input.value;
    input.value = value

    this.form.get('general_discount')?.setValue(value);
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      product.discount = value
      this.productsForm.get(`final_price_${product.id}`)?.setValue(this.getFinalPrice(product));
      return {
        ...product,
        discount: value,
        final_price: this.productsForm.get(`final_price_${product.id}`)?.value,
        variants: product.variants?.map(variant => {
          variant.discount = value
          this.productsForm.get(`variant_${variant.id}_final_price`)?.setValue(this.getFinalPrice(variant));
          return {
            ...variant,
            discount: value,
            final_price: this.productsForm.get(`variant_${variant.id}_final_price`)?.value
          }
        })
      }
    })
  }

  onGeneralIncrementChange(event: any){
    if (!this.canSubmit) return;
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      return {
        ...product,
        increment: event.target.value ? +event.target.value : undefined,
        variants: product.variants?.map(variant => {
          return {
            ...variant,
            increment: event.target.value ? +event.target.value : undefined,
          }
        })
      }
    })
  }

  onGeneralMinChange(event: any){
    if (!this.canSubmit) return;
    const value = event.target.value;
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      return {
        ...product,
        min_qte: value ? +value : undefined,
        variants: product.variants?.map(variant => {
          return {
            ...variant,
            min_qte: value ? +value : undefined
          }
        })
      }
    })
  }

  onGeneralMaxChange(event: any){
    if (!this.canSubmit) return;
    const value = event.target.value;
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      return {
        ...product,
        max_qte: value ? +value : undefined,
        variants: product.variants?.map(variant => {
          return {
            ...variant,
            max_qte: value ? +value : undefined,
          }
        })
      }
    })
  }

restoreQuantity() {
  if (!this.canSubmit) return;
  this.selectedProducts = this.selectedProducts.map((prod, i) => {
      this.form.get('increment')?.setValue(1);
      this.form.get('min_qte')?.setValue(1);
      this.form.get('max_qte')?.setValue(null);
      this.generalRules = this.form.value;
    return {
      ...prod,
      min_qte: (prod.variants && prod.variants.length > 0) ? this.generalRules.min_qte :  prod.init_min_qte || this.generalRules.min_qte,
      max_qte: (prod.variants && prod.variants.length > 0) ? this.generalRules.max_qte :  prod.init_max_qte || this.generalRules.max_qte,
      increment: (prod.variants && prod.variants.length > 0) ? this.generalRules.increment : prod.init_increment || this.generalRules.increment,
      variants: prod.variants?.map((v, j) => {
        return {
          ...v,
          min_qte:   v.init_min_qte ? v.init_min_qte : this.generalRules.min_qte,
          max_qte:   v.init_max_qte ? v.init_max_qte : this.generalRules.max_qte,
          increment: v.init_increment ? v.init_increment : this.generalRules.increment,
        };
      }) ?? []
    };
  });
}


  getFMarkUp(product: IProduct): number | null {
    const finalPrice = this.getFinalPrice(product);

    return finalPrice ? +(finalPrice - product.cost).toFixed(2) : null;
  }

  getFMarkUpVariant(variant: IVariant): number | null {
    const finalPrice = this.getFinalPrice(variant);
    return finalPrice ? +(finalPrice - variant.cost!).toFixed(2) : null ;
  }

  openOverride(index: number, element: IProduct | IVariant, typeProduct: string){
    if (!this.canSubmit) return;
    const dialogRef = this.dialog.open(CustomeOverrideComponent, {
      data: element,
      disableClose: true,
    })
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        if(typeProduct === 'product'){
          if(result.increment){
            this.selectedProducts[index].increment = +result.increment
          }
          if(result.min_qte){
            this.selectedProducts[index].min_qte = +result.min_qte
          }
          if(result.max_qte){
            this.selectedProducts[index].max_qte = +result.max_qte
          }
          if(result.can_be_sold_out_of_stock !== undefined){
            this.selectedProducts[index].can_be_sold_out_of_stock = result.can_be_sold_out_of_stock
          }
        }else if (typeProduct === 'variant'){
          const variant = this.selectedProducts[index].variants?.find(variant => variant.id === result.id);
          if(result.increment){
            variant!.increment = +result.increment
          }
          if(result.min_qte){
            variant!.min_qte = +result.min_qte
          }
          if(result.max_qte){
            variant!.max_qte = +result.max_qte
          }
          if(result.can_be_sold_out_of_stock !== undefined){
            variant!.can_be_sold_out_of_stock = result.can_be_sold_out_of_stock
          }
        }
        
        if (
            typeProduct === 'product' &&
            (
              this.selectedProducts[index].variants &&
              this.selectedProducts[index].variants?.length !== 0
            )
          ){
          this.selectedProducts[index].variants?.forEach(variant => {
            if(result.increment){
              variant.increment = +result.increment
            }
            if(result.min_qte){
              variant.min_qte = +result.min_qte
            }
            if(result.max_qte){
              variant.max_qte = +result.max_qte
            }
          })
        }
      }
    });
  }

  sanitize(event: any) {
    event.target.value = event.target.value.replace(/[^\d]/g, '');
  }

  onCanBeSoldOutOfStockChange(event: any) {
    if (!this.canSubmit) return;
    const value = event.checked;
    this.selectedProducts = this.selectedProducts.map((product: IProduct, index) => {
      if(product.variants && product.variants.length > 0 ){
        this.selectedProducts[index].variants = this.selectedProducts[index].variants?.map(variant => {
          return {
            ...variant,
            can_be_sold_out_of_stock: value,
          }
        })
      }
      return {
        ...product,
        can_be_sold_out_of_stock: value,
      }
    })
  }

  disableScrollChange(event: WheelEvent) {
    event.preventDefault();
  }

  doesProductHaveRetailPrice(product: IProduct) {
    if(product.variants?.length) {
      return product.variants.some((variant: any) => (variant.final_price && variant.final_price <= 0) || !variant.final_price)
    } else {
      return (product.final_price && product.final_price <= 0) || !product.final_price;
    }
  }

  save(): boolean | void {
    if (!this.canSubmit) return;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return false
    }

    if (this.productsForm.invalid) {
      const invalidProductIdsSet = new Set<number>();

      // Products with invalid variants
      Object.keys(this.productsForm.controls).forEach(controlName => {
        if (controlName.startsWith('variant_') && this.productsForm.get(controlName)?.invalid) {
          const match = controlName.match(/^variant_(\d+)_/);
          if (match) {
            const variantId = Number(match[1]);

            const product = this.selectedProducts.find(product =>
              product.variants?.some(variant => variant.id === variantId)
            );

            if (product && product.id) {
              invalidProductIdsSet.add(product.id);
            }
          }
        }
      });

      this.invalidProductIds = Array.from(invalidProductIdsSet)
      this.productsForm.markAllAsTouched();

      return false
    }
    this.saveCustomProducts.emit({
      customProducts: this.selectedProducts,
      generalRules: this.form.value
    });
    this.saveGeneraleRule.emit(this.form.value);
  }

  logFormErrors(formGroup: FormGroup | FormArray, parentKey: string = '') {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (control instanceof FormGroup || control instanceof FormArray) {
        this.logFormErrors(control, fullKey);
      } else if (control && control.invalid) {
        console.log(`Invalid control: ${fullKey}`, control.errors);
      }
    });
  }

  validateNumber(event: any) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    const key = event.key;

    if (!/[\d.,]/.test(key)) {
      event.preventDefault();
      return;
    }

    // Prevent multiple decimals
    if (/[,.]/.test(key) && /[,.]/.test(value)) {
      event.preventDefault();
      return;
    }

    if (value.endsWith(',') || value.endsWith('.')) return;

    // Restrict to 2 decimal places
    const [integerPart, decimalPart] = value.split(/[,.]/);
    if (decimalPart && decimalPart.length >= 2) {
      event.preventDefault();
      return;
    }
  }

  cancel(){
    const submitType = this.submitType === 'stepper' ? 'stepper' : 'summary';
    this.cancelCustom.emit(submitType)
  }

  getLengthProductsPlusVariants() {
    let length = 0;
    this.selectedProducts.forEach(product => {
      length += product.variants?.length || 1;
    });
    return length;
  }

  submitPermission(): HasPermissionContext {
    return { module: 'catalog', action: this.submitType === 'stepper' ? 'create' : 'edit' };
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
